import { Platform } from 'react-native';

export function canvasFingerprint(hash: (data: string) => string): string {
  if (Platform.OS !== 'web' || typeof document === 'undefined') {
    return 'native-' + Platform.OS;
  }

  try {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    if (!ctx) return 'no-canvas';

    ctx.textBaseline = 'top';
    ctx.font = '14px Arial';
    ctx.fillStyle = '#1F6C4F';
    ctx.fillText('Coach Cedar Device ID', 2, 2);

    const canvasData = canvas.toDataURL();
    return hash(canvasData).substring(0, 8);
  } catch {
    return 'no-canvas';
  }
}
